import React from 'react';
import { Config } from 'types';
import { Email, GitLab, LinkedIn, Resume } from 'icons';

const config: Config = {
  name: {
    display: 'Joaquín Miranda, PhD',
    aria: 'My name is Joaquín Miranda',
  },
  title: {
    display: 'Computational Materials Scientist',
    aria: 'I am a computational materials scientist',
  },
  buttons: [
    {
      display: 'GitLab',
      aria: 'Visit my GitLab profile',
      icon: <GitLab />,
      href: 'https://gitlab.com/miranda.joaquin',
    },
    {
      display: 'LinkedIn',
      aria: 'Visit my LinkedIn profile',
      icon: <LinkedIn />,
      href: 'https://www.linkedin.com/in/joaqu%C3%ADn-miranda-28327546/',
    },
    {
      display: 'Resume',
      aria: 'View my resume in Google Drive',
      icon: <Resume />,
      href: 'https://drive.google.com/file/d/1ydPPqgH8dzoZd60oYAbNBGEqXqX2swh8/view?usp=drive_link',
    },
    {
      display: 'Email',
      aria: 'Send me an email',
      icon: <Email />,
      href: 'mailto:miranda.joaquin@gmail.com',
    },
  ],
};

export default config;
